<template>
  <div class="qa-pure-wrap">
    <!-- {{originArea}} -->
    <div class="point-bg">
      <img
        src="https://cbgccdn.thecover.cn/@/images/20220112/1641980459664003465.png"
        alt=""
      />
    </div>

    <div class="title">
      <div  class="dhwrap">
        <img
          class="dh"
          src="https://cbgccdn.thecover.cn/@/images/20220112/1641977217258071969.png"
          alt=""
        />
        <div class="titlewrap">
          <div class="title-w">请回答</div>
          <div class="title-n">1921-2021</div>
        </div>
      </div>

      <img
        class="title-pic"
        src="//wximg.chuanbaoguancha.cn/FnjJD4JOUzOk-SdJXnNvFwN6GJmg"
        alt=""
      />
    </div>

    <transition name="modal">
      <div class="start-wrap" v-if="showStartBtn">
        <button class="btn" @click="startQA">开始挑战</button>
      </div>
    </transition>

    <transition name="modal">
      <questionWrap
        class="questions"
        :time="time"
        v-if="showQuestions"
        v-on:record-result="recordResult"
        v-on:finish="onAnswerFinish"
      ></questionWrap>
    </transition>
    <transition name="">
      <div class="result-wrap" v-if="showResult">
        你答对了<span>{{ rightNumber }}</span
        >题<br />
        请继续努力！
        <div style="margin-top: 20px">
          <button class="btn" @click="restart">返回</button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
// import page from "@/components/page";
import questionWrap from "./question-wrap.vue";
// import { getAreaTree, getAreaMap } from "./area";
import { Field, Popup, Cascader, Toast } from "vant";
import { doCheck } from "../../apis/index";
export default {
  components: { Field, Popup, Cascader, questionWrap },
  data() {
    return {
      showStartBtn: true,
      showAreaPopup: false,
      showQuestions: false,
      showResult: false,

      rightNumber: 0,
      answerRecords: [],

      fieldValue: "",
      cascaderValue: "",
      originArea: undefined,

      timer: "",
      time: 0,
    };
  },
  created() {
    // this.startQA();
  },
  methods: {
    onSelectFinish({ selectedOptions }) {
      this.showAreaPopup = false;
      this.originArea = [...selectedOptions];
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    restart() {
      this.showResult = false;
      setTimeout(() => {
        this.showStartBtn = true;
      }, 500);
      // this.startQA()
    },
    startQA() {
      this.showStartBtn = false;
      setTimeout(() => {
        this.showQuestions = true;
        this.timer = setInterval(() => {
          this.time++;
        }, 1000);
      }, 500);
    },
    recordResult(payload) {
      this.answerRecords.push(payload.result);
    },
    onAnswerFinish() {
      clearInterval(this.timer);
      this.time = 0;
      this.rightNumber = this.answerRecords.filter((item) => item).length;
      this.showQuestions = false;
      setTimeout(() => {
        this.showResult = true;
        this.answerRecords = [];
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.qa-pure-wrap {
  // background: #AB3738 url('//wximg.chuanbaoguancha.cn/Fr6GU8AVq9XzQDBvSYpkmVHrvzwQ') top right no-repeat;\
  // background-image:url('https://cbgccdn.thecover.cn/@/images/20220112/1641976981407064800.png')  ;
  background: linear-gradient(rgb(112, 32, 33) 0%, #f65859 100%);
  // background-repeat: no-repeat;
  // background-position: 20% 5vh;
  // background-size: 300px auto;
  // background-size: 60% auto;
  height: 100%;
  width: 100%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.point-bg {
  position: fixed;
  width: 20vw;
  bottom: 1vw;
  left: 50%;
  margin-left: -10vw;
  z-index: 100;
  // background: url('https://cbgccdn.thecover.cn/@/images/20220112/1641977726918014382.png') center center;
  pointer-events: none;
  opacity: 1;
  img {
    width: 100%;
  }
}
.title {
  // : 1vh;
  width: 100%;

  position: relative;
  // left: 0;
  // top: 0;
  padding: 5vh;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.5;
  color: #f9c789;
  
  font-weight: bold;
  font-style: italic;
  text-align: left;

  .dhwrap{
    display: flex;
    .dh {
    // position: absolute;
    width: 10vw;
    // flex: 0 0 ;
    width: 10vw;
    height: 10vw;
    // left: 0;
    margin-right: 20px;
    }
  }
  .titlewrap{
    font-size: 4vw;
  }
  
  .title-pic {
    flex: 0 0 auto;
    // width: 515px;
    width: 40vw;
    // margin-left: 100px;
  }
}
.btns {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
.result-wrap {
  // margin-top: 50px;
  margin-top: 10vh;
  text-align: center;
  color: #fbe8a9;
  font-size: 5vw;
  .btn {
    height: 7vw;
  }
  span {
    font-size: 6vw;
  }
}
.start-wrap {
  // padding-top: 150px;
  margin-top: 200px;
  .btn {
    width: 30vw;
    height: 7vw;
    font-size: 5vw;
  }
}
.questions {
  max-width: 85%;
  margin: 0 auto;
  margin-top: 10vh;
  // font-size: 45px;
}
</style>